import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Modal, Platform, View } from 'react-native';
import { component } from '../../Decorators/Component';
import { PressableButtonView } from '../Buttons/PressableButtonView';
import { H3View } from '../Typography/H3View';
import { ParagraphView } from '../Typography/Paragraph';
import { CoreConfig } from './../../../CoreConfig';
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { useColorScheme } from '../../Hooks/UseColorScheme';
import { ThemeContext } from '../../Contexts/ThemeContext';
export const PopUpView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.popUp,
    style(theme, mediaQuery, window, props) {
        return {
            header: {
                marginBottom: 20
            },
            body: {},
            footer: {
                margin: -10,
                flexDirection: 'row',
                flexWrap: 'wrap',
                alignItems: 'center',
                justifyContent: 'center'
            },
            interaction: {
                padding: 10
            },
            title: {
                marginBottom: 0,
                textAlign: 'center'
            },
            description: {
                marginBottom: 0,
                textAlign: 'center'
            },
            container: {
                flex: 1,
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(0, 0, 0, 0.4)'
            },
            content: Object.assign(Object.assign(Object.assign({ width: '100%', maxWidth: window.width - 20, paddingHorizontal: 35, paddingVertical: 20 }, mediaQuery.sm({
                maxWidth: 440
            })), { borderRadius: 8 }), Platform.select({
                android: {
                    elevation: 4,
                },
                default: {
                    shadowColor: '#000',
                    shadowOffset: {
                        width: 0,
                        height: 6
                    },
                    shadowOpacity: 0.1,
                    shadowRadius: 10
                }
            }))
        };
    }
})(({ title, description, interactions, visible, onDismiss, style, children }) => {
    const [isOpen, setIsOpen] = useState(visible);
    const [popUpTitle, setPopUpTitle] = useState(title);
    const [popUpDescription, setPopUpDescription] = useState(description);
    const [popUpInteractions, setPopUpInteractions] = useState(interactions);
    const color_scheme = useColorScheme();
    useEffect(() => {
        setIsOpen(visible);
        if (visible) {
            const defaultInteractions = [
                {
                    action: 'ok',
                    type: 'primary',
                    text: 'OK',
                    onPress: () => {
                        setIsOpen(false);
                        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                    }
                }
            ];
            setPopUpInteractions(interactions || defaultInteractions);
            setPopUpTitle(title);
            setPopUpDescription(description);
        }
    }, [visible, description, title, interactions]);
    return (_jsx(ThemeContext.Provider, { value: (style === null || style === void 0 ? void 0 : style.color_scheme) || { scheme: 'default' }, children: _jsx(Modal, { animationType: 'fade', transparent: true, visible: isOpen, children: _jsx(View, { style: style === null || style === void 0 ? void 0 : style.container, children: _jsxs(View, { style: [style === null || style === void 0 ? void 0 : style.content, { backgroundColor: color_scheme.colors.background }], children: [_jsx(View, { style: style === null || style === void 0 ? void 0 : style.header, children: _jsx(H3View, { textStyle: style === null || style === void 0 ? void 0 : style.title, children: popUpTitle || '' }) }), _jsx(View, { style: [style === null || style === void 0 ? void 0 : style.body, (popUpInteractions || []).length > 0 && { marginBottom: 20 }], children: children || (_jsx(ParagraphView, { textStyle: style === null || style === void 0 ? void 0 : style.description, children: popUpDescription })) }), !!popUpInteractions && (_jsx(View, { style: style === null || style === void 0 ? void 0 : style.footer, children: popUpInteractions.map((interaction, i) => (_jsx(View, { style: [style === null || style === void 0 ? void 0 : style.interaction, (popUpInteractions || []).length === 1 && { maxWidth: 200, width: '100%' }], children: _jsx(PressableButtonView, Object.assign({}, interaction, { onPress: () => {
                                        var _a;
                                        (_a = interaction.onPress) === null || _a === void 0 ? void 0 : _a.call(interaction);
                                        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                                    }, containerStyle: Object.assign({ width: undefined, flex: undefined }, interaction.containerStyle), wrapperStyle: Object.assign({ width: undefined, flex: undefined }, interaction.wrapperStyle) })) }, interaction.action || i))) }))] }) }) }) }));
});
